import * as React from 'react';

import { cn } from '../utils';

function Card({ className, testId, ...props }: React.ComponentProps<'div'> & { testId?: string }) {
  return (
    <div
      data-slot='card'
      data-testid={testId}
      className={cn(
        'bg-background-input text-foreground-base flex flex-col gap-lg rounded-xl border border-border-base shadow-sm transition-all duration-200',
        className
      )}
      {...props}
    />
  );
}

function CardHeader({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-header'
      className={cn(
        '@container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-sm px-lg pt-lg has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-lg',
        className
      )}
      {...props}
    />
  );
}

function CardTitle({ className, ...props }: React.ComponentProps<'h4'>) {
  return <h4 data-slot='card-title' className={cn('leading-none', className)} {...props} />;
}

function CardDescription({ className, ...props }: React.ComponentProps<'p'>) {
  return (
    <p data-slot='card-description' className={cn('text-foreground-muted', className)} {...props} />
  );
}

function CardAction({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-action'
      className={cn('col-start-2 row-span-2 row-start-1 self-start justify-self-end', className)}
      {...props}
    />
  );
}

function CardContent({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot='card-content' className={cn('px-lg py-md', className)} {...props} />;
}

function CardFooter({ className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      data-slot='card-footer'
      className={cn('flex items-center px-lg pb-lg [.border-t]:pt-lg', className)}
      {...props}
    />
  );
}

export { Card, CardHeader, CardFooter, CardTitle, CardAction, CardDescription, CardContent };
